<template>
  <div class="content">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'main-content',
  data() {
    return {};
  },
};
</script>

<style scoped>
.content {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// MainContent.vue?9774c646